import React, { FC, useState } from 'react';

import { Stack, HStack, Text, Box } from '@chakra-ui/react';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { CopyIcon } from 'components/Icons';
import { renderCopyIcon } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/utils';
import { CommandBox } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/utils/CommandBox';

interface Props {
  command: string;
}

export const GetEmailIdOfServiceAccount: FC<Props> = props => {
  const { command } = props;
  const [copied, setCopied] = useState('');

  return (
    <Stack spacing={4}>
      <HStack align={'start'}>
        <HelpCount count={1} />
        <HStack>
          <Text fontWeight={600}>
            Execute the following command in CloudShell
          </Text>
          <Box color="primary">
            {renderCopyIcon(
              {
                copyText: command,
                icon: <CopyIcon p={0.5} color="primary" />,
                tooltip: 'Copy command',
              },
              copied,
              setCopied,
            )}
          </Box>
        </HStack>
      </HStack>
      <Box pl={8}>
        <CommandBox>{command}</CommandBox>
      </Box>
    </Stack>
  );
};
